import { Component, ChangeDetectionStrategy } from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-partner-tracking-tab',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './partner-tracking-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-tracking-tab.component.scss'
})
export class PartnerTrackingTabComponent {

}
